import { useSocialProviders } from "@/react/hooks";
import { OptionButton } from "@/react/components/OptionButton";
import { OptionSkeleton } from "@/react/components/OptionSkeleton";
import { routes, useSimpleKitContext } from "@/react/context/SimpleKitContext";
import { INetwork, NetworkSymbols } from "based-auth/networks";
import { IChain } from "based-auth/chains";
import { useEffect } from "react";
import {
  DiscordLogo,
  GithubLogo,
  GoogleLogo,
  TwitterLogo,
  WrongChainLogo,
} from "based-assets";
import { useAccount } from "@/react/hooks";
import { NetworkButton } from "@/react/components/NetworkButton";

const socialIcons = {
  google: GoogleLogo,
  github: GithubLogo,
  twitter: TwitterLogo,
  discord: DiscordLogo,
};

export function Home() {
  const { data: socialProviders, isPending } = useSocialProviders();
  const { chains, setPendingItem, setRouter } = useSimpleKitContext();
  const { users } = useAccount();

  const networks: INetwork[] = Object.values(
    chains.reduce((acc: any, chain: IChain) => {
      acc[chain.network.symbol] = chain.network;
      return acc;
    }, {})
  );

  useEffect(() => {
    setPendingItem(null);
  }, []);

  if (isPending) {
    return (
      <div className="web3kit-space-y-2">
        {Array.from({ length: 3 }).map((_, index) => (
          <OptionSkeleton key={index} index={index} className="web3kit-h-12" />
        ))}
      </div>
    );
  }

  return (
    <div className="web3kit-space-y-2">
      <div className="web3kit-flex web3kit-items-center web3kit-gap-2">
        {networks.map((network: INetwork, index: number) => {
          return (
            <NetworkButton
              index={index}
              network={network}
              key={network.symbol}
              onClick={() => {
                switch (network.symbol) {
                  case NetworkSymbols.eth:
                    setRouter(routes.selectETHWallet);
                    break;
                  case NetworkSymbols.sol:
                    setRouter(routes.selectSolanaWallet);
                    break;
                }
              }}
            />
          );
        })}
      </div>
      {socialProviders
        .filter(
          (provider: any) =>
            !users.some((user) => user.provider === provider.id)
        )
        .map((provider: any, index: number) => {
          const Logo =
            socialIcons[provider.id as keyof typeof socialIcons] ||
            WrongChainLogo;
          return (
            <OptionButton
              key={provider.id}
              index={index}
              logo={Logo}
              onClick={() => {
                setRouter(() => {
                  setPendingItem({
                    id: provider.id,
                    chainId: chains[0].id,
                    logo: Logo,
                    network: "",
                    description: `We connect your "${provider.name}" account to our platform.`,
                  });
                  return routes.socialConnecting;
                });
              }}
            >
              {provider.name}
            </OptionButton>
          );
        })}
    </div>
  );
}
